import { combineReducers } from '@reduxjs/toolkit';
import hotelDestinations from './hotelDestinations/slice';
import allHotels from './hotels/allHotels/slice';
import multimedia from './hotels/multimedia/slice';
import hotelDescriptions from './hotels/descriptions/slice';
import webDestinationPrompt from './hotels/descriptions/webDestinationPromptsSlice';
import factCheck from './hotels/factCheck/slice';

export default combineReducers({
  hotelDestinations,
  allHotels,
  multimedia,
  hotelDescriptions,
  webDestinationPrompt,
  factCheck,
});
